import React from 'react';
import io from 'socket.io-client';
import { prizeWithAmount } from './components/prizeIcon';

// Overlay de la clasificacion de una liga, para ponerlo de browser source en OBS:
//   https://forallia.com/?streamGadgets=leagueOverlay
//
// Que liga se ve se decide desde el panel (Ligas -> Gestionar -> "Mostrar en overlay"); solo
// puede haber una a la vez. Sin ninguna marcada esto no pinta NADA, ni fondo ni cartel, para
// poder dejar la fuente siempre puesta en la escena y encenderla y apagarla desde el panel.
//
// Parametros de la URL:
//   &scale=1.4  ajuste fino del tamaño, por si el escalado automatico no cuadra con el marco
//   &top=5      recorta a los N primeros; sin el sale la clasificacion completa

const overlayParams = new URLSearchParams(window.location.search);

// Mismo parseo y clamp que la alerta de recompensas (rewardsHistory.jsx). Tambien lo usa el
// overlay de torneos (torneos.jsx).
export const overlayScale = (() => {
    const raw = parseFloat(overlayParams.get('scale'));
    if (!isFinite(raw) || raw <= 0) return 1;
    return Math.min(3, Math.max(0.5, raw));
})();

const overlayTop = (() => {
    const raw = parseInt(overlayParams.get('top'), 10);
    if (!isFinite(raw) || raw <= 0) return 0;
    return raw;
})();

const SUBLEAGUE_DEFAULT = 'General';

const LeagueOverlay = () => {
    const [data, setData] = React.useState(null);

    const load = React.useCallback(async () => {
        try {
            const res = await fetch('/api/games?overlay=1', { method: 'POST' });
            setData(await res.json());
        } catch (err) {
            console.error('Error cargando el overlay de liga:', err);
        }
    }, []);

    React.useEffect(() => {
        load();

        const socket = io('https://forallia.com');
        socket.on('leagueOverlay', (payload) => setData(payload || null));
        // Tras una reconexion se han podido perder eventos: se vuelve a sincronizar.
        socket.on('connect', load);

        return () => {
            socket.off('leagueOverlay');
            socket.off('connect', load);
        };
    }, [load]);

    // El overlay se ve sobre la escena de OBS y html tiene color de fondo propio en App.css:
    // hay que anularlo siempre, tambien cuando no hay liga.
    React.useEffect(() => {
        document.documentElement.style.backgroundColor = 'transparent';
        document.body.style.overflow = 'hidden';
    }, []);

    if (!data || !data.league) return null;

    const league = data.league;
    const rows = overlayTop > 0 ? (data.rows || []).slice(0, overlayTop) : (data.rows || []);
    const titulo = league.name + (league.subLeague === SUBLEAGUE_DEFAULT ? '' : ' - ' + league.subLeague);

    return (
        <div className='leagueOverlay heroes' style={{ '--overlayScale': overlayScale }}>
            <div className='leagueOverlayBox'>
                <div className='leagueOverlayTitle'>
                    <span className='leagueOverlayGame'>{titulo}</span>
                    <span className='leagueOverlaySeason'>Temporada {league.season}</span>
                </div>
                <table className='leagueOverlayTable'>
                    <tbody>
                        {rows.map(row => (
                            <tr key={row.userId}>
                                <td className='leagueOverlayPos'>{row.position}</td>
                                <td className='leagueOverlayName'>{row.displayname}</td>
                                <td className='leagueOverlayPoints'>{row.totalPoints}</td>
                                <td className='leagueOverlayPrize'>
                                    {prizeWithAmount(row.prize, 'leagueOverlayPrizeImg', 'leagueOverlayPrizeAmount')}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LeagueOverlay;
